module.exports = __webpack_public_path__ + "img/auth-bg-1.6de432d0.jpg";